export enum DynamicPackagesFormStepNames {
  GUESTS = 'guestDetailsStep',
  ROOM_EXTRAS = 'roomExtrasStep',
  SPA_EXTRAS = 'spaExtrasStep',
  SELECT_SPA_EXPERIENCE = 'selectSpaExperience',
  EXPERIENCE = 'experienceStep',
  TABLES = 'tablesStep',
}
